export type UserRoleName =
    'architect' |
    'commercial client' |
    'domestic client' |
    'builder' |
    'building inspector' |
    'building inspector company'
    ;

export const getLoginUserRoleName = async (): Promise<UserRoleName | ''> => {
    try {
        const userTypeName = await Promise.resolve(localStorage.getItem('user_type_name'));
        const roleName = userTypeName ? userTypeName.toLowerCase() : '';

        const validRoles: UserRoleName[] =
            [
                'architect',
                'commercial client',
                'domestic client',
                'builder',
                'building inspector',
                'building inspector company'
            ];
        return validRoles.includes(roleName as UserRoleName) ? (roleName as UserRoleName) : '';
    } catch (error) {
        return '';
    }
};